<template>
  <q-form @submit.prevent="$emit('submit')">
    <template v-for="(item, index) in definition" :key="index">
      <div v-if="!item.if || item.if(formData)">
        <!-- Section Header -->
        <div v-if="item.type === 'header'" :class="['flex items-center q-mb-lg', item.class]">
          <img :src="item.icon" class="q-mr-md" />
          <p class="q-ma-none"><strong>{{ item.text }}</strong></p>
        </div>
        <!-- Row of fields -->
        <div v-else-if="item.type === 'row'" class="row">
          <div
            v-for="(field, fieldIndex) in item.fields"
            :key="fieldIndex"
            :class="field.colClass || 'col'"
          >
            <!-- Si el field trae options (ej. radios) -->
            <template v-if="field.options">
              <component
                v-for="option in field.options"
                :key="option.value"
                :is="componentMap[field.component] || field.component"
                v-model="formData[field.model]"
                :class="['q-mr-lg', field.class]"
                dense
                v-bind="field.props"
                :label="option.label"
                :val="option.value"
              />
              <div
                v-if="v$[field.model]?.$error"
                class="text-negative text-caption q-ml-md q-mb-lg"
              >
                {{ v$[field.model]?.$errors[0]?.$message }}
              </div>
            </template>
            <!-- Si no trae options, renderizamos normal -->
            <component
              v-else
              :is="componentMap[field.component] || field.component"
              v-model="formData[field.model]"
              :class="field.class"
              v-bind="field.props"
              :dependency="field.dependency ? formData[field.dependency] : undefined"
              :error="v$[field.model]?.$error"
              :error-message="v$[field.model]?.$errors[0]?.$message"
              @blur="v$[field.model]?.$touch()"
            >
              <template v-if="field.slots?.prepend" #prepend>
                <div class="row items-center full-height">
                  <span class="text-grey-7 q-pr-sm custom-prepend-number">
                    {{ field.slots.prepend.text }}
                  </span>
                  <q-separator vertical />
                </div>
              </template>
            </component>
          </div>
        </div>
      </div>
    </template>
    <slot name="actions"></slot>
  </q-form>
</template>

<script setup>
import { computed } from 'vue';
import BaseInput from './BaseInput.vue';
import BaseSelect from './BaseSelect.vue';
import BaseRadio from './BaseRadio.vue';

const componentMap = {
  BaseInput,
  BaseSelect,
  BaseRadio,
};

const props = defineProps({
  modelValue: { type: Object, required: true },
  definition: { type: Array, required: true },
  v$: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['update:modelValue', 'submit']);

const formData = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});
</script>
<style>
.q-mt-xxl {
    margin-top: 96px;
}
</style>
